import React from 'react';
import "./style.css";

const index = () => {
  return (
    <div className='p_box'>
      <div className="p_box_1"></div>
      <div className="p_box_2"></div>
    </div>
  );
}

export default index
